var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manage-requests",class:_vm.classes},[_c('manage-requests-header',{attrs:{"show-ignore-btn":_vm.requests.length > 0},on:{"ignoreAll":_vm.ignoreAll}}),(_vm.requests.length)?_c('manage-requests-list',{attrs:{"requests":_vm.requests}}):_c('manage-requests-empty-screen',{attrs:{"loading":_vm.loading},on:{"retry":_vm.retry}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }